import { pgSelect, pgInsert, edgeFunctionUrl } from './supabaseClient';
import { loadConfig } from './configService';
import { logEvent } from './debugLog';

/**
 * 🏢 Corporate pack — visitor check-in (feature: 'checkin'). A 🪪 button on
 * the landing screen collects name / company / host / purpose, logs the
 * visit (Dashboard → 🪪 Check-ins) and emails the venue's ops recipients,
 * then offers to navigate the visitor to reception (or their host's desk if
 * a POI matches the host name).
 */

export interface Checkin {
  id: string;
  map_code: string;
  visitor_name: string;
  company: string | null;
  host: string | null;
  purpose: string | null;
  status: 'checked_in' | 'done';
  created_at: string;
}

export interface NewCheckin {
  visitorName: string;
  company?: string;
  host?: string;
  purpose?: string;
}

export async function submitCheckin(c: NewCheckin): Promise<void> {
  const mapCode = loadConfig().code;
  await pgInsert('checkins', {
    map_code: mapCode,
    visitor_name: c.visitorName,
    company: c.company ?? null,
    host: c.host ?? null,
    purpose: c.purpose ?? null,
  });
  logEvent('session', `check-in: ${c.visitorName}${c.host ? ` → ${c.host}` : ''}`);
  // Notification is best-effort — the check-in row is the record.
  fetch(edgeFunctionUrl('notify-checkin'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      mapCode,
      visitorName: c.visitorName,
      company: c.company,
      host: c.host,
      purpose: c.purpose,
    }),
  }).catch(() => undefined);
}

/** Dashboard: recent check-ins (staff-only via RLS). */
export async function listCheckins(mapCode: string): Promise<Checkin[]> {
  return pgSelect<Checkin>(
    'checkins',
    `select=*&map_code=eq.${encodeURIComponent(mapCode)}&order=created_at.desc&limit=100`,
  );
}
